import { useTranslation } from "react-i18next";
import Seo from "../../components/Seo/Seo";
import "./Governance.css";

export default function DownloadsTemplate({ titleKey, descriptionKey, files, seoTitleKey, seoDescKey, seoPath }) {
  const { t } = useTranslation("common");

  return (
    <section className="page">
      <Seo 
        title={t(seoTitleKey)} 
        description={t(seoDescKey)} 
        path={seoPath} 
      />

      <div className="container">
        <div className="pageHead">
          <h1>{t(titleKey)}</h1>
          <p className="muted">{t(descriptionKey)}</p>
        </div>

        <div className="downloads">
          {files.map((file, i) => (
            <div key={i} className="card pad download">
              <div className="download-info">
                <h3>{t(file.titleKey)}</h3>
                <p>{t(file.descKey)}</p>
              </div>

              <a href={file.url} className="btn btn-primary" download>
                {t("governance.downloadButton")}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}